// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "styles" + "." + "e90b6e2b6a6ec33e1690" + ".css";
};